import { useState } from "react";
import Button from "../../components/base/Button";
import {
  useSEO,
  generateOrganizationSchema,
  generateWebPageSchema,
} from "../../utils/seo";

export default function Home() {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  const [isCalendlyModalOpen, setIsCalendlyModalOpen] = useState(false);

  const openVideoModal = () => setIsVideoModalOpen(true);
  const closeVideoModal = () => setIsVideoModalOpen(false);

  const openDemoModal = () => setIsDemoModalOpen(true);
  const closeDemoModal = () => setIsDemoModalOpen(false);

  const openCalendlyModal = () => setIsCalendlyModalOpen(true);
  const closeCalendlyModal = () => setIsCalendlyModalOpen(false);

  useSEO({
    title: "Moveideias - Transformamos ideias em resultados digitais",
    description:
      "Estratégia, criatividade e tecnologia para tornar simples os processos complexos da sua logística. Soluções TeuPedido, MoveCourier e MovePipe.",
    keywords:
      "logística, gestão de pedidos, rastreamento, automação, TeuPedido, MoveCourier, MovePipe, transformação digital",
    canonical: "/",
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        generateOrganizationSchema(),
        generateWebPageSchema({
          name: "Moveideias - Transformamos ideias em resultados digitais",
          description:
            "Estratégia, criatividade e tecnologia para tornar simples os processos complexos da sua logística.",
          url: "/",
        }),
      ],
    },
  });

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(34, 26, 50, 0.8), rgba(34, 26, 50, 0.8)), url('/images/backgrounds/hero-background.jpeg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Transformamos ideias em resultados digitais que impulsionam a
              logística do seu negócio.
            </h1>
            <p className="text-xl md:text-2xl text-[#e7eaf6] mb-8 leading-relaxed">
              Estratégia, criatividade e tecnologia lado a lado para tornar
              simples os processos complexos da sua logística.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="bg-[#f28c1a] text-white hover:bg-[#cc7013] transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={openCalendlyModal}
              >
                Solicitar demonstração
              </Button>
              <Button
                size="lg"
                className="bg-[#f28c1a] text-white hover:bg-[#cc7013] transition-colors duration-200 whitespace-nowrap cursor-pointer"
                onClick={openVideoModal}
              >
                Conheça nossas soluções
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {isVideoModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-[#221a32]">
                Vídeo institucional
              </h3>
              <button
                onClick={closeVideoModal}
                className="text-[#221a32] hover:text-[#f28c1a] cursor-pointer"
                aria-label="Fechar vídeo"
              >
                <i className="ri-close-line text-2xl" />
              </button>
            </div>
            <div className="aspect-video">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/m-BDG5js58c"
                title="Vídeo Institucional Moveideias"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                referrerpolicy="strict-origin-when-cross-origin"
              />
            </div>
          </div>
        </div>
      )}

      {/* Demo Modal */}
      {isDemoModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-[#221a32]">
                Solicitar contato
              </h3>
              <button
                onClick={closeDemoModal}
                className="text-[#221a32] hover:text-[#f28c1a] cursor-pointer"
                aria-label="Fechar formulário"
              >
                <i className="ri-close-line text-2xl" />
              </button>
            </div>
            <div className="h-[600px]">
              <iframe
                width="100%"
                height="100%"
                src="https://portal.moveideias.com/workflow/public/form/9ec92cd7-ac11-4a04-8a8a-6d71c473e303"
                title="Formulário de Solicitação de Contato"
                frameBorder="0"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      )}

      {/* Calendly Modal */}
      {isCalendlyModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-[#221a32]">
                Agendar demonstração
              </h3>
              <button
                onClick={closeCalendlyModal}
                className="text-[#221a32] hover:text-[#f28c1a] cursor-pointer"
                aria-label="Fechar Calendly"
              >
                <i className="ri-close-line text-2xl" />
              </button>
            </div>
            <div className="h-[600px]">
              <iframe
                width="100%"
                height="100%"
                src="https://calendly.com/move-comercial/60min"
                title="Agendamento de demonstração"
                frameBorder="0"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      )}

      {/* Problemas que Resolvemos */}
      <section
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), url('/images/backgrounds/problems-background.jpg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#221a32] mb-6">
              Sua empresa merece mais do que boas ideias. Merece gestão,
              transparência logística e resultados.
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Transformamos os desafios logísticos da sua empresa em
              oportunidades de crescimento. Com soluções tecnológicas
              inteligentes, eliminamos gargalos operacionais, aumentamos a
              visibilidade dos processos e reduzimos custos, proporcionando uma
              gestão mais eficiente e resultados mensuráveis para o seu negócio.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-[#e7eaf6] p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-[#f28c1a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-line text-2xl text-white" />
              </div>
              <h3 className="text-xl font-bold text-[#221a32] mb-3">
                Visibilidade 360º
              </h3>
              <p className="text-gray-600">
                Controle total sobre todos os processos logísticos em tempo
                real.
              </p>
            </div>

            <div className="bg-[#e7eaf6] p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-[#5a6ab0] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-robot-line text-2xl text-white" />
              </div>
              <h3 className="text-xl font-bold text-[#221a32] mb-3">
                Automação inteligente
              </h3>
              <p className="text-gray-600">
                Eliminamos tarefas repetitivas e padronizamos operações
                complexas.
              </p>
            </div>

            <div className="bg-[#e7eaf6] p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-[#f28c1a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-2xl text-white" />
              </div>
              <h3 className="text-xl font-bold text-[#221a32] mb-3">
                Redução de custos
              </h3>
              <p className="text-gray-600">
                Otimização de recursos e eliminação de desperdícios
                operacionais.
              </p>
            </div>

            <div className="bg-[#e7eaf6] p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-[#5a6ab0] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-bar-chart-line text-2xl text-white" />
              </div>
              <h3 className="text-xl font-bold text-[#221a32] mb-3">
                Decisões orientadas por dados
              </h3>
              <p className="text-gray-600">
                Analytics avançados para decisões estratégicas precisas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Nossas Soluções */}
      <section
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(231, 234, 246, 0.95), rgba(231, 234, 246, 0.95)), url('/images/backgrounds/solutions-background.jpg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#221a32] mb-6">
              Soluções essenciais que descomplicam sua operação logística.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* TeuPedido */}
            <div className="bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-white/50">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mb-6 bg-cover bg-center"
                style={{
                  backgroundImage: `linear-gradient(rgba(234, 88, 54, 0.9), rgba(234, 88, 54, 0.9))`,
                }}
              >
                <i className="ri-shopping-cart-line text-2xl text-white" />
              </div>
              <h3 className="text-2xl font-bold text-[#221a32] mb-4">
                TeuPedido
              </h3>
              <p className="text-gray-600 mb-6">
                Plataforma completa de gestão de pedidos que integra as
                funcionalidades de OMS e TMS, centralizando e automatizando todo
                o processo logístico, da coleta à entrega final, com mais
                eficiência e visibilidade.
              </p>
              <Button
                size="sm"
                variant="outline"
                className="border-[#ea5836] text-[#ea5836] hover:bg-[#ea5836]"
                href="/teupedido"
              >
                Saiba mais
              </Button>
            </div>

            {/* MoveCourier */}
            <div className="bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-white/50">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mb-6 bg-cover bg-center"
                style={{
                  backgroundImage: `linear-gradient(rgba(75, 181, 171, 0.9), rgba(75, 181, 171, 0.9))`,
                }}
              >
                <i className="ri-truck-line text-2xl text-white" />
              </div>
              <h3 className="text-2xl font-bold text-[#221a32] mb-4">
                MoveCourier
              </h3>
              <p className="text-gray-600 mb-6">
                Solução tecnológica de logística que otimiza rotas, garante
                rastreamento e comprovação digital de entregas em tempo real,
                proporcionando mais eficiência e transparência.
              </p>
              <Button
                size="sm"
                variant="outline"
                className="border-[#ea5836] text-[#ea5836] hover:bg-[#ea5836] mt-6"
                href="/movecourier"
              >
                Saiba mais
              </Button>
            </div>

            {/* MovePipe */}
            <div className="bg-white/90 backdrop-blur-sm p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-white/50">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mb-6 bg-cover bg-center"
                style={{
                  backgroundImage: `linear-gradient(rgba(90, 106, 176, 0.9), rgba(90, 106, 176, 0.9))`,
                }}
              >
                <i className="ri-flow-chart text-2xl text-white" />
              </div>
              <h3 className="text-2xl font-bold text-[#221a32] mb-4">
                MovePipe
              </h3>
              <p className="text-gray-600 mb-6">
                Ferramenta de automação de fluxos de trabalho que conecta
                diferentes sistemas e padroniza processos internos da empresa.
                Ótimo para os processos adjacentes da logística da sua empresa.
              </p>
              <Button
                size="sm"
                variant="outline"
                className="border-[#ea5836] text-[#ea5836] hover:bg-[#ea5836] mt-6"
                href="/movepipe"
              >
                Saiba mais
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Impactos Gerados */}
      <section
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), url('/images/backgrounds/impacts-section.jpg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#221a32] mb-6">
              O que nossas soluções podem fazer pela sua empresa.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#f28c1a] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-speed-up-line text-xl text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#221a32] mb-3">
                  Aumento da eficiência operacional
                </h3>
                <p className="text-gray-600">
                  Automatizamos tarefas repetitivas, padronizando rotinas e
                  eliminando retrabalhos.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#5a6ab0] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-eye-line text-xl text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#221a32] mb-3">
                  Visibilidade e transparência end-to-end
                </h3>
                <p className="text-gray-600">
                  Rastreie o ciclo completo de pedidos, atividades de campo e
                  fluxos de trabalho internos em tempo real.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#f28c1a] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-money-dollar-circle-line text-xl text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#221a32] mb-3">
                  Redução de custos operacionais
                </h3>
                <p className="text-gray-600">
                  Elimine falhas, audite a performance e fretes dos parceiros
                  logísticos e digitalize processos manuais para economizar.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-[#5a6ab0] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-customer-service-line text-xl text-white" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-[#221a32] mb-3">
                  Melhoria da experiência do cliente
                </h3>
                <p className="text-gray-600">
                  Envie atualizações em tempo real e comprove entregas,
                  aumentando a satisfação e fidelização.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Números da Empresa */}
      <section
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(34, 26, 50, 0.95), rgba(34, 26, 50, 0.95)), url('/images/backgrounds/company-stats-section.jpg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Números que comprovam nossa excelência.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            <div className="text-center bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20">
              <div className="w-16 h-16 bg-[#f28c1a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-2xl text-white" />
              </div>
              <div className="text-4xl font-bold text-white mb-2">+10M</div>
              <p className="text-[#e7eaf6] text-lg">
                Arquivos trafegados no último ano
              </p>
            </div>

            <div className="text-center bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20">
              <div className="w-16 h-16 bg-[#5a6ab0] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-notification-line text-2xl text-white" />
              </div>
              <div className="text-4xl font-bold text-white mb-2">+1M</div>
              <p className="text-[#e7eaf6] text-lg">
                Notificações proativas no último ano
              </p>
            </div>

            <div className="text-center bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20">
              <div className="w-16 h-16 bg-[#4bb5ab] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-2xl text-white" />
              </div>
              <div className="text-4xl font-bold text-white mb-2">+550</div>
              <p className="text-[#e7eaf6] text-lg">
                Integrações com transportadoras
              </p>
            </div>

            <div className="text-center bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20">
              <div className="w-16 h-16 bg-[#f28c1a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-2xl text-white" />
              </div>
              <div className="text-4xl font-bold text-white mb-2">+10K</div>
              <p className="text-[#e7eaf6] text-lg">
                Usuários ativos nas plataformas
              </p>
            </div>

            <div className="text-center bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20 md:col-span-2 lg:col-span-2">
              <div className="w-16 h-16 bg-[#5a6ab0] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-2xl text-white" />
              </div>
              <div className="text-4xl font-bold text-white mb-2">6 Países</div>
              <p className="text-[#e7eaf6] text-lg mb-4">
                Presença internacional consolidada
              </p>
              <div className="flex flex-wrap justify-center gap-3">
                {[
                  "Brasil",
                  "México",
                  "Colômbia",
                  "Argentina",
                  "Peru",
                  "Guatemala",
                ].map((country) => (
                  <span
                    key={country}
                    className="bg-white/20 px-3 py-1 rounded-full text-sm text-white"
                  >
                    {country}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Clientes */}
      <section
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), url('/images/backgrounds/clients-section.jpg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#221a32] mb-6">
              Clientes que confiam na Moveideias
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Tornaram simples o processo logístico com transparência e
              eficiência da informação.
            </p>
          </div>

          <div className="relative overflow-hidden">
            <div className="flex space-x-12 items-center animate-scroll w-max">
              {/* Primeiro conjunto de logos */}
              {[
                {
                  src: "/images/clients/merck.jpeg",
                  alt: "Merck",
                },
                {
                  src: "/images/clients/gsk.png",
                  alt: "GSK",
                },
                {
                  src: "/images/clients/diageo.png",
                  alt: "Diageo",
                },
                {
                  src: "/images/clients/fisia.png",
                  alt: "Fisia",
                },
                {
                  src: "/images/clients/inbetta.jpeg",
                  alt: "Inbetta",
                },
                {
                  src: "/images/clients/wilson-sons.jpeg",
                  alt: "Wilson Sons",
                },
                {
                  src: "/images/clients/keko.jpeg",
                  alt: "Keko",
                },
                {
                  src: "/images/clients/hita.png",
                  alt: "Hita",
                },
                {
                  src: "/images/clients/transportador-timbas.jpeg",
                  alt: "Transportador Timbas",
                },
                {
                  src: "/images/clients/renner.jpeg",
                  alt: "Renner",
                },
                {
                  src: "/images/clients/pro-analise.png",
                  alt: "Pró-Análise",
                },
                {
                  src: "/images/clients/haleon.jpeg",
                  alt: "Haleon",
                },
              ].map((logo, index) => (
                <div
                  key={`first-${index}`}
                  className="flex-shrink-0 w-40 h-20 bg-white rounded-lg shadow-sm flex items-center justify-center p-4 hover:shadow-md transition-shadow duration-300"
                >
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="max-w-full max-h-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer"
                  />
                </div>
              ))}

              {/* Segundo conjunto de logos (duplicado para animação contínua) */}
              {[
                {
                  src: "/images/clients/merck.jpeg",
                  alt: "Merck",
                },
                {
                  src: "/images/clients/gsk.png",
                  alt: "GSK",
                },
                {
                  src: "/images/clients/diageo.png",
                  alt: "Diageo",
                },
                {
                  src: "/images/clients/fisia.png",
                  alt: "Fisia",
                },
                {
                  src: "/images/clients/inbetta.jpeg",
                  alt: "Inbetta",
                },
                {
                  src: "/images/clients/wilson-sons.jpeg",
                  alt: "Wilson Sons",
                },
                {
                  src: "/images/clients/keko.jpeg",
                  alt: "Keko",
                },
                {
                  src: "/images/clients/hita.png",
                  alt: "Hita",
                },
                {
                  src: "/images/clients/transportador-timbas.jpeg",
                  alt: "Transportador Timbas",
                },
                {
                  src: "/images/clients/renner.jpeg",
                  alt: "Renner",
                },
                {
                  src: "/images/clients/pro-analise.png",
                  alt: "Pró-Análise",
                },
                {
                  src: "/images/clients/haleon.jpeg",
                  alt: "Haleon",
                },
              ].map((logo, index) => (
                <div
                  key={`second-${index}`}
                  className="flex-shrink-0 w-40 h-20 bg-white rounded-lg shadow-sm flex items-center justify-center p-4 hover:shadow-md transition-shadow duration-300"
                >
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="max-w-full max-h-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
